module.exports = __webpack_public_path__ + "img/applyOversea.ce6b6655.png";